module.exports = __webpack_public_path__ + "static/img/chuangan.c52f563.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/hardware/chuangan.png
// module id = 3Uao
// module chunks = 1